import emojiRegex from 'emoji-regex'

{
  const cookieName = "_rv" // intentionally naming this something weirder than "rose_nominee_votes" for obfuscation I guess

  function getCookieIds(){
    const cookie = window.coolHelperFunctions.getTemporaryLocalStorage(cookieName)
    return cookie?.length ? cookie.split(",") : []
  }

  function setCookieIds(nomineeId){
    const savedIds = getCookieIds()
    savedIds.push(nomineeId)
    window.coolHelperFunctions.setTemporaryLocalStorage(cookieName, savedIds.join(","), 1, "days")
  }

  function userHasVotedFor(nomineeId){
    var savedIds = getCookieIds()
    return savedIds.length && savedIds.indexOf(nomineeId) != -1
  }

  document.querySelectorAll('.rose-awards-voting-app').forEach(el => {
    const thankYou = el.querySelector('h3')
    const form = el.querySelector('form')
    const loader = el.querySelector('.big-loading-indicator')
    const nomineeId = window.coolHelperFunctions.getURLParam("nominee-id")

    // initialize the form state
    loader.remove()
    if(!userHasVotedFor(nomineeId)){
      thankYou.remove()
      form.style.opacity = 1
    } else {
      form.remove()
      thankYou.style.display = 'block'
    }

    form.addEventListener('submit', e => {
      e.preventDefault()
      const comment = form.querySelector('textarea').value
      if(comment.match(emojiRegex())){
        alert("Your voting comment cannot contain an emoji.")
        return
      }

      if(form.checkValidity()){
        setCookieIds(nomineeId)
        form.submit()
      } else {
        form.reportValidity()
      }
    })
  })
}